import { render, staticRenderFns } from "./ColoursBar.vue?vue&type=template&id=3505d04d"
var script = {}
import style0 from "./ColoursBar.vue?vue&type=style&index=0&id=3505d04d&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports